import type { ButtonProps, Direction, Position } from 'uikit';
import { Button, Tooltip } from 'uikit';
import { getElementCoordinatesBySelector } from 'utils/dom';

import type React from 'react';
import type { CSSProperties } from 'react';
import { useCallback, useState } from 'react';

type ButtonWithTooltipType = ButtonProps & {
    direction?: Direction;
    tooltipText: string;
    style?: CSSProperties;
    isTooltipHidden?: boolean;
    className?: string;
    classNameTooltip?: string;
    id?: string;
};

export const ButtonWithTooltip: React.FC<ButtonWithTooltipType> = (props) => {
    const { size, classNameTooltip, direction, tooltipText, isTooltipHidden, className, style, id, ...rest } = props;
    const [position, setPosition] = useState<Position>(undefined);

    const onMouseEnter = useCallback((event: React.MouseEvent) => {
        setPosition(getElementCoordinatesBySelector(event.target, '', true));
    }, []);

    const onMouseLeave = useCallback(() => {
        setPosition(undefined);
    }, []);

    return (
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} style={style}>
            <Button id={id} className={className} size={size} style={style} {...rest} />
            {!isTooltipHidden && (
                <Tooltip
                    className={classNameTooltip}
                    size={(size || 's') as any}
                    direction={direction}
                    position={position}
                    style={{ zIndex: 1 }}
                >
                    {tooltipText}
                </Tooltip>
            )}
        </div>
    );
};

ButtonWithTooltip.displayName = 'ButtonWithTooltip';
